import type { ReactElement } from 'react';

import type IPicture from 'models/IPicture';
import Picture from 'components/shared/Picture';

import { Component as CartIcon } from 'icons/icon-ui--cart-small.svg';
import { Component as SaleTagIcon } from 'icons/icon-ui--sale-tag.svg';
import { Component as AwardStarIcon } from 'icons/icon-ui--award-star.svg';

type Props = {
  imageVersions: IPicture[];
  title: string;
  salesTagEnabled: boolean;
  isPremiumTagEnabled?: boolean;
  isProgramPage?: boolean;
};

function RecipeImage(
  {
    imageVersions, title,
    salesTagEnabled, isPremiumTagEnabled = false,
    isProgramPage = false,
  }: Props,
): ReactElement {
  return (
    <div className="c-recipe__content--top">
      <div className="c-recipe__image-wrapper">
        {salesTagEnabled && (
          <div className="c-recipe__sale_tag">
            <SaleTagIcon />
            SALE
          </div>
        )}
        {isPremiumTagEnabled && (
          <div className="c-recipe__premium_tag">
            <AwardStarIcon />
            PREMIUM
          </div>
        )}
        { !isProgramPage && (
        <div className="c-recipe__added">
          <CartIcon className="c-svg-stroke-primary-alt-color" />
          In my cart
        </div>
        )}
        <Picture isProgramPage={isProgramPage} versions={imageVersions} alt={title} />
      </div>
    </div>
  );
}

export default RecipeImage;
